export default __webpack_public_path__ + "static/media/Party.bade5fd8.svg";